// Import components.
import Overlay from './components/Overlay.jsx';

/**
 * <pre>
 * Overlay module React Components.
 *
 * Summary of responsibilities:
 *
 *  - defines React components that this app module can render
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Overlay
 * @namespace
 *
 * @type {Object}
 */
const Components = {
	Overlay: Overlay
};

export default Components;